<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <p-card styleClass="very-compact-card p-3">
    <div class="p-fluid">
      <div class="field">
        <label class="font-medium required-field">Название</label>
        <crm-input-text
          [(value)]="type.name"
          [isError]="$any(errors?.name)"></crm-input-text>
        <small
          *ngIf="errors?.name"
          class="p-error">
          {{ errors.name | join }}
        </small>
      </div>
    </div>
  </p-card>

  <p-card styleClass="mt-3 very-compact-card p-3">
    <h3 class="mb-0">Новые поля</h3>

    <crm-table
      *ngIf="type.attributes?.length"
      [columns]="attributeColumns"
      [values]="type.attributes || []"
      styleClass="p-datatable-sm mt-2 eav-entity-type-attributes-table">
      <ng-template
        #rowTemplate
        let-attribute="item">
        <ng-container *ngIf="toAttribute(attribute) as attribute">
          <tr>
            <td class="eav-attr-name-col">
              <crm-input-text
                [(value)]="attribute.name"
                class="w-full"></crm-input-text>
            </td>
            <td>
              <crm-single-select
                [options]="attributeTypes"
                [(selectedItem)]="attribute.type"
                [isTemplateCombined]="true"
                [filter]="false"
                [showClear]="true"
                optionValue="name"
                (selectedItemChange)="onAttributeTypeChange(attribute, $event)"
                appendTo="body">
                <ng-template
                  #itemTemplate
                  let-type="item">
                  {{ type?.value | eavAttributeValueTypeName }}
                </ng-template>
              </crm-single-select>
            </td>
            @if (isHelpDeskModuleEnabled) {
              <td class="min-w-12rem">
                <crm-multi-select
                  [options]="attributeStatuses"
                  [(selectedItems)]="attribute.requiredOnHdTaskStatuses"
                  [maxSelectedLabels]="1"
                  [showClear]="true"
                  appendTo="body"></crm-multi-select>
              </td>
            }
            <td>
              <div class="field-checkbox mb-0">
                <p-checkbox
                  [(ngModel)]="attribute.showInPersonalAccount"
                  [binary]="true"
                  [disabled]="!isShowInPersonalAccountEditable(attribute.type)"
                  [inputId]="'showInPa-' + attribute.id"></p-checkbox>
              </div>
            </td>
            <td>
              <div
                *ngIf="
                  attribute.type === EavAttributeValueTypeEnum.FILIAL ||
                  attribute.type === EavAttributeValueTypeEnum.COST_CENTER ||
                  attribute.type === EavAttributeValueTypeEnum.ROOM
                "
                class="field-checkbox mb-0">
                <p-checkbox
                  [(ngModel)]="attribute.multipleSelect"
                  [binary]="true"
                  inputId="multipleSelect"></p-checkbox>
                <label [for]="'multipleSelect'">Множественный выбор</label>
              </div>
            </td>
            <td>
              <i
                class="pi pi-times text-red-500 hover:text-red-300 cursor-pointer"
                style="font-size: 1.3rem"
                (click)="deleteAttribute(attribute)"></i>
            </td>
          </tr>

          @if (attribute.type === EavAttributeValueTypeEnum.COMPUTED) {
            <tr>
              <td
                colspan="99"
                class="pt-0 border-none">
                <p-card styleClass="mt-2 very-compact-card p-3">
                  <h3 class="m-0 required-field">Формула</h3>
                  <p-messages severity="info">
                    <ng-template pTemplate="">
                      <div class="flex gap-3">
                        <i
                          class="pi pi-exclamation-circle mt-1"
                          style="font-size: 1.3rem"></i>
                        <div>
                          <p>
                            Введите формулу, по которой будет вычисляться
                            {{ attribute.name?.length ? '"' + attribute.name + '"' : 'поле' }}.
                          </p>
                          <p>
                            Для добавления в формулу значения, нужно нажать на кнопку {{ '"{x}"' }}.
                          </p>
                          <p class="mt-2">Доступные математические операции: + - * /</p>
                          <p>Доступные сложные выражения с учетом скобок.</p>
                        </div>
                      </div>
                    </ng-template>
                  </p-messages>

                  <div class="p-fluid">
                    <div class="field">
                      <div class="p-inputgroup crm-formula-inputgroup">
                        <crm-input-text
                          [(value)]="attribute.expression"
                          class="w-full"
                          placeholder="50000 * (100 / 50)"
                          (contextmenu)="openComputedAttributeTokens($event, attribute); $event.preventDefault()"
                          (keydown.escape)="keydownEscInExpressionInput($any($event))"></crm-input-text>
                        <crm-button
                          type="button"
                          label="{x}"
                          (onClick)="openComputedAttributeTokens($event, attribute)"></crm-button>
                      </div>
                      @if (attribute.expression) {
                        <p class="my-2">
                          {{ attribute.expression | eavComputedExpression: type.tokens }}
                        </p>
                      }
                    </div>
                  </div>
                </p-card>
              </td>
            </tr>
          }
        </ng-container>
      </ng-template>
    </crm-table>

    <div
      *ngIf="attributeErrors?.length"
      class="mb-3">
      <small class="p-error">
        {{ attributeErrors | join }}
      </small>
    </div>

    <crm-button
      label="Добавить"
      icon="pi pi-plus"
      styleClass="p-button-success p-button-text mt-2"
      (onClick)="addAttribute()"></crm-button>
  </p-card>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveEavEntityType()"></crm-button>
      <div class="flex align-items-center gap-2">
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && !type.deleted"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteEavEntityType()"></crm-button>
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && type.deleted"
          icon="pi pi-undo"
          label="Восстановить"
          styleClass="p-button-info p-button-text"
          (onClick)="restoreEavEntityType()"></crm-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>

<p-overlayPanel
  #opExpression
  [style]="{ width: '250px' }"
  (onShow)="isShowOverlayPanel = true"
  (onHide)="isShowOverlayPanel = false"
  styleClass="dropdown-overlay-panel">
  <ng-template pTemplate="">
    <p-tree
      [value]="computedAttributeTokensTree | orderBy: 'label:string'"
      (onNodeSelect)="selectComputedAttributeToken($event.node); opExpression.hide()"
      [filter]="true"
      selectionMode="single"
      scrollHeight="250px"
      [style]="{ 'max-height': '300px' }"
      styleClass="compact-list"></p-tree>
  </ng-template>
</p-overlayPanel>
